import styled from "styled-components";
import Background from "./OfficeDeskStuffBackground.svg"
import {ITheme} from "pu-crossproduct-components/build/themes";

interface Theme {
    theme: ITheme
}

export const PageHolder = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: 0 0 0 0;
  padding: 0 0 0 0;
`

export const PageContent = styled.div<Theme>`
  flex: 1;
  background-color: #F9F9F9 ;
  background-image: url(${Background});
  background-repeat: no-repeat;
  background-position: top right;
  display: flex;
  justify-content: center;
  padding-left: 40px;
  padding-right: 40px;
  width: calc(100% - 80px);

  background-size: 400px;

  @media (min-width: 600px) {
    background-size: 500px;
  }

  @media (min-width: 800px) {
    background-size: 600px;
  }

  @media (min-width: 1000px) {
    background-size: 700px;
  }

  @media (min-width: 1200px) {
    background-size: 800px;
  }
`
